import {getGuestThemeQueryValue} from '@toolify/client/src/modules/authentication/functions/getGuestThemeQueryValue'
import {getStoredGuestTheme} from '@toolify/client/src/modules/authentication/functions/getStoredGuestTheme'

// Gosc jawnie wybral motyw (parametr ?t=… albo zapisany motyw goscia) - wtedy zapamietany motyw light nie obowiazuje.
// Ten sam warunek sprawdza skrypt inline w src/index.html - zmieniac w obu miejscach
export function hasExplicitGuestTheme(): boolean {
  return Boolean(getGuestThemeQueryValue() || getStoredGuestTheme())
}
